import { CustomTable } from "@/components/Tables/CustomTable"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import React from "react"
import { columns } from "./Columns"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import { useNavigate } from "react-router-dom"
import RoleModal from "./RoleModal"

const defaultRoleNames = ["super-admin", "admin", "manager", "cashier"]

const RoleList = () => {
  return (
    <>
      <>
        <div className="breadcrumb-card">
          <h5>Roles</h5>
        </div>

        <CrudProvider>
          <RoleTable />
        </CrudProvider>
      </>
    </>
  )
}

function RoleTable() {
  const { data: response, isLoading } = useCustomQuery(["role"], "role")
  const { openDialog } = useCrudContext()
  return (
    <>
      <CustomTable
        apiPath="role"
        columns={columns}
        data={response?.data.data}
        isLoading={isLoading}
        label="Roles"
        canEditRow={(role) => !defaultRoleNames.includes(role.name)}
        canDeleteRow={(role) => !defaultRoleNames.includes(role.name)}
      />

      {openDialog ? <RoleModal /> : null}
    </>
  )
}

export default RoleList
